import { supabase } from '../lib/supabase';
import { logError } from '../utils/logger';

export const upsertClient = async ({ name, phone, email }) => {
  const { error } = await supabase.from('clients').insert([{ name, phone, email }]);
  if (error && error.code !== '23505') {
    await logError(supabase, 'general', `Client insert failed: ${error.message}`, { email });
  }
};

export const fetchServicesAndShopData = async () => {
  const [{ data: cats }, { data: svcs }, { data: hours }, { data: hols }, { data: slots }, { data: lbData }] = await Promise.all([
    supabase.from('service_categories').select('*').eq('is_active', true).order('sort_order'),
    supabase.from('services').select('*').eq('is_active', true).order('sort_order'),
    supabase.from('shop_hours').select('*'),
    supabase.from('shop_holidays').select('*'),
    supabase.from('booking_slots').select('id,booking_date,status,total_duration').not('status', 'eq', 'cancelled'),
    supabase.from('shop_settings').select('key,value').in('key', ['lunch_break_enabled','lunch_break_start','lunch_break_end']),
  ]);
  const lbMap = Object.fromEntries((lbData || []).map(r => [r.key, r.value]));
  return {
    categories:       cats  || [],
    services:         svcs  || [],
    shopHours:        hours || [],
    holidays:         hols  || [],
    existingBookings: slots || [],
    lunchBreak: {
      enabled: lbMap.lunch_break_enabled === 'true',
      start:   lbMap.lunch_break_start || '12:00',
      end:     lbMap.lunch_break_end   || '13:00',
    },
  };
};
